module.exports = __webpack_public_path__ + "static/media/solution_rtPlus_bicouche.ab91aaa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution_rtPlus_bicouche.png
// module id = 1149
// module chunks = 0